const tabPanelController = () => {
    const tabSwitchers = document.querySelectorAll('[data-tab-switcher]');

    if (!tabSwitchers.length) {
        return;
    }

    tabSwitchers.forEach(function(switcher) {
        switcher.addEventListener('click', function(e) {
            e.preventDefault();
            const tab = document.querySelector(`[data-event-name="waysToBuyTab"] a[href="${e.target.hash}"]`);
            if (tab) {
                tab.click();
            }
        });
    });
};

export default tabPanelController;
